import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"
import _imports_0 from '../assets/images/logo.svg'


const _hoisted_1 = { class: "sticky inset-x-0 top-0 z-50 bg-white shadow-md shadow-blaze-orange-500/5 transition duration-500" }
const _hoisted_2 = {
  class: "flex items-center justify-between gap-x-6 p-4 lg:px-8",
  "aria-label": "Global"
}
const _hoisted_3 = { class: "flex lg:flex-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-8 w-auto",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "bg-gradient-to-r from-blaze-orange-600 to-blaze-orange-300 text-2xl ml-4 font-quicksand font-bold bg-clip-text [&::-webkit-text-fill-color]:transparent",
  style: {"-webkit-text-fill-color":"transparent"}
}, "Clique Social", -1)
const _hoisted_6 = { class: "hidden lg:flex lg:gap-x-12" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-1 items-center justify-end gap-x-6"
}
const _hoisted_8 = {
  key: 1,
  class: "flex flex-1 items-center justify-end"
}
const _hoisted_9 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_10 = { class: "hidden md:ml-4 lg:flex lg:flex-shrink-0 lg:items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-1.5" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)
const _hoisted_13 = {
  key: 0,
  class: "h-8 w-8 rounded-full",
  src: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  alt: ""
}
const _hoisted_14 = {
  key: 1,
  class: "inline-block h-8 w-8 overflow-hidden rounded-full bg-gray-100"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-full w-full text-gray-300",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })
], -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "flex lg:hidden" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 z-50" }, null, -1)
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "-m-1.5 p-1.5 flex items-center"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-8 w-auto",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-white text-xl ml-4 font-quicksand font-bold" }, "Clique Social")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close menu", -1)
const _hoisted_23 = { class: "mt-6 flow-root" }
const _hoisted_24 = { class: "-my-6 divide-y divide-gray-500/25" }
const _hoisted_25 = { class: "space-y-2 py-6" }
const _hoisted_26 = {
  key: 0,
  class: "border-t border-gray-700 pb-3 pt-4"
}
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-10 w-10 rounded-full",
    src: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: ""
  })
], -1)
const _hoisted_29 = { class: "ml-3" }
const _hoisted_30 = { class: "text-base font-medium text-white" }
const _hoisted_31 = { class: "text-sm font-medium text-gray-400" }
const _hoisted_32 = {
  type: "button",
  class: "relative ml-auto flex-shrink-0 rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-1.5" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "View notifications", -1)
const _hoisted_35 = { class: "mt-3 -ml-3 space-y-1" }
const _hoisted_36 = {
  key: 1,
  class: "py-6"
}

import { ref } from "vue";
import { Dialog, DialogPanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import { BellIcon, Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline';
import { PlusIcon } from '@heroicons/vue/20/solid';
import { useUserStore } from "@/stores/userStore";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavbarComponent',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();
const mobileMenuOpen = ref(false);

const navigation = [
  { name: 'Home', link: '/' },
  { name: 'Why Clique Social?', link: 'why' },
  { name: 'Contact', link: 'contact' }
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "-m-1.5 p-1.5 flex items-center"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
          return _createVNode(_component_router_link, {
            class: "text-sm font-semibold leading-6 text-cod-gray-800",
            "active-class": "!text-blaze-orange-600",
            key: item.name,
            to: item.link
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        }), 64))
      ]),
      (!_unref(userStore).userAuth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/auth/login",
              class: "hidden lg:block lg:text-sm lg:font-semibold lg:leading-6 lg:text-cod-gray-800"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Log In ")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/auth/register",
              class: "rounded-md bg-blaze-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blaze-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blaze-orange-600"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Sign Up ")
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_unref(userStore).user?.isEventOrganiser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'OrganiserDashboard' }))),
                    type: "button",
                    class: "relative inline-flex items-center gap-x-1.5 rounded-md bg-blaze-orange-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blaze-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blaze-orange-600"
                  }, [
                    _createVNode(_unref(PlusIcon), {
                      class: "-ml-0.5 h-5 w-5",
                      "aria-hidden": "true"
                    }),
                    _createTextVNode(" Create Events ")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(Menu), {
                as: "div",
                class: "relative ml-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(MenuButton), { class: "relative flex items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-blaze-orange-500 focus:ring-offset-2" }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _hoisted_12,
                        (_unref(userStore).user?.profilePic)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                          : (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_16)),
                        _createVNode(_unref(ChevronDownIcon), {
                          class: "ml-2 h-5 w-5 text-gray-400",
                          "aria-hidden": "true"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_Transition, {
                    "enter-active-class": "transition ease-out duration-200",
                    "enter-from-class": "transform opacity-0 scale-95",
                    "enter-to-class": "transform opacity-100 scale-100",
                    "leave-active-class": "transition ease-in duration-75",
                    "leave-from-class": "transform opacity-100 scale-100",
                    "leave-to-class": "transform opacity-0 scale-95"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MenuItems), { class: "absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MenuItem), null, {
                            default: _withCtx(({ active }) => [
                              _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(userStore).logout())),
                                class: _normalizeClass([active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700'])
                              }, "Sign out", 2)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          type: "button",
          class: "-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-400",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (mobileMenuOpen.value = true))
        }, [
          _hoisted_18,
          _createVNode(_unref(Bars3Icon), {
            class: "h-6 w-6",
            "aria-hidden": "true"
          })
        ])
      ])
    ]),
    _createVNode(_unref(Dialog), {
      as: "div",
      class: "lg:hidden",
      onClose: _cache[5] || (_cache[5] = ($event: any) => (mobileMenuOpen.value = false)),
      open: mobileMenuOpen.value
    }, {
      default: _withCtx(() => [
        _hoisted_19,
        _createVNode(_unref(DialogPanel), { class: "fixed inset-y-0 right-0 z-50 w-full h-fit overflow-y-auto bg-gray-900 px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-white/10" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("button", {
                type: "button",
                class: "-m-2.5 rounded-md p-2.5 text-gray-400",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (mobileMenuOpen.value = false))
              }, [
                _hoisted_22,
                _createVNode(_unref(XMarkIcon), {
                  class: "h-6 w-6",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                    return _createVNode(_component_router_link, {
                      class: "-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white hover:bg-gray-800",
                      "active-class": "text-blaze-orange-600",
                      key: item.name,
                      to: item.link
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  }), 64))
                ]),
                (_unref(userStore).userAuth)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(userStore).user?.firstName) + " " + _toDisplayString(_unref(userStore).user?.lastName), 1),
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(userStore).user?.username), 1)
                        ]),
                        _createElementVNode("button", _hoisted_32, [
                          _hoisted_33,
                          _hoisted_34,
                          _createVNode(_unref(BellIcon), {
                            class: "h-6 w-6",
                            "aria-hidden": "true"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_DisclosureButton, {
                          as: "a",
                          href: "#",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(userStore).logout())),
                          class: "block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Sign out")
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(_component_router_link, {
                        to: "/auth/login",
                        class: "-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-white hover:bg-gray-800"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Log In ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, {
                        to: "/auth/register",
                        class: "-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-white hover:bg-gray-800"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Sign Up ")
                        ]),
                        _: 1
                      })
                    ]))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})